import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "appFont text-2xl" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "text-gray-500 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("b", _hoisted_2, [
      (_ctx.count != null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.count), 1))
        : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
    ]),
    _hoisted_4,
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1)
  ]))
}